import React, { useMemo } from "react";
import { Switch, Route } from "react-router-dom";
import { Token } from "./controllers/Token";
import { Login } from "./controllers/account/Login";
import { useAuthContext } from "./contexts/Auth";
import { useFeatureAccessContext } from "./contexts/FeaturesAccess";
import { toAbsoluteRouterUrl } from "../_metronic/_helpers";
import { PrivateRoutes } from "./PrivateRoutes";
import Store from "./contexts/Store";
import useStore from "../redux/store";
import { useSnackContext } from "./contexts/Snack";
import { DevMode } from "./components";

export const Routes = () => {
  const {auth, reLogin} = useAuthContext();
  const featureAccess = useFeatureAccessContext();
  const { open, openError, openSuccess, openAxiosError } = useSnackContext();

  const iniStore = useMemo(() => {
    return {
      auth: auth,
      config: {...featureAccess.config, snack: {open, openError, openSuccess, openAxiosError}}
    }
  }, [auth, featureAccess.config, open, openError, openSuccess, openAxiosError])
  const store = useStore(iniStore);
  return (
    <>
      {auth.loaded && 
        <Store {...{store}}>
          <Switch>
            <Route path={toAbsoluteRouterUrl("Token/:paramToken")} exact={true} component={Token} />
            {auth.isAuthenticated &&
              <Route path={toAbsoluteRouterUrl(`dev`)}>
                <DevMode/>
              </Route>
            }
            {auth.isAuthenticated &&
              <Route path={toAbsoluteRouterUrl(`Dev`)}>
                <DevMode/>
              </Route>  
            }
            {auth.isAuthenticated &&
              <PrivateRoutes />
            }
            {!auth.isAuthenticated &&
              <>
                <Route path={toAbsoluteRouterUrl("Login")} exact={true} component={Login} />
                <Route path="*" component={Login}/> 
              </>
            }
          </Switch>
        </Store>            
      }
    </>
  );
}
